
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import SpecialsScreen from './specials';
import { useRefresh } from '../../hooks/useRefresh';
import ListProducts from './ListProducts';
import BeerScreen from './beer'
import CategoriesScreen from './categories';
// import MargaritasScreen from './margaritas.js'
// import WinesScreen from './wines.js'
// import SpiritsScreen from './spirits.js'
// import BottlesScreen from './bottles.js'

function Index({setShowHappy}) { 

    const {i18n} = useTranslation();

        const {change} = useRefresh();
    
     const [menus, setMenus] = useState([]);

    const [showSpecials, setShowSpecials] = useState(false);
    const [showCoctatik, setshowCoctatik] = useState(false);
    const [showBeers, setshowBeers] = useState(false);
     const [showCategories, setshowCategories] = useState(false);
     const [showListProduct, setShowListProduct] = useState(false);
     const [dishs, setdishs] = useState(false);
    const [beers, setbeers] = useState(false);
      const [noalcol, setnoalcol] = useState(false);

        
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            
            setMenus(data);
        });
    }, [change]);


      useEffect(() => {
            menus.map((item) => {
            if (item.id === 731) {
                setshowCoctatik(item);
            }
            if (item.id === 758) {
                setbeers(item);
            }
                
            if (item.id === 763) {
                setnoalcol(item);
            }
           
            });
      }, [menus]);
    
    
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showImageTop={false} showLamp={false} goCategories={setshowCategories} showBack={true} setShowSpecials={setShowSpecials} setShowListProduct={setShowHappy}>
                <div  style={{padding: '0 20px'}}>
                    
                    <h1 style={{ color: 'white', textTransform: 'uppercase', fontSize: 40, fontWeight: "900", marginTop: 250}}>
                         cervezas/beers
                    </h1>
                    
                    <div style={{display: 'flex', justifyContent: 'space-between', paddingInline: 30, flexDirection: 'column', alignItems: 'center'}}>
                        <div onClick={() => {
                            setdishs(beers)
                            setShowListProduct(true)
                            }}
                            className='shadow'
                            style={{
                                width: 290,
                                height: 70,
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginBottom: 5,
                                display: 'flex',
                                backgroundColor: '#fff',
                            }}>
                                <div style={{
                                    width: '100%',
                                    display: 'flex', justifyContent: 'center',
                                    position: 'relative',
                                    alignItems: 'center',}}>
                                        
                                        <p
                                    style={{
                                            fontWeight: '900',
                                            fontSize:30,
                                            color: '#ED3E08',
                                            textTransform: 'uppercase',
                                            textAlign: 'center',
                                            paddingHorizontal: 30,
                                            position: 'absolute',
                                        }}>
                                            domestic
                                        </p>
                                </div>
                        </div>

                         <div onClick={() => {
                            setdishs(showCoctatik)
                            setShowListProduct(true)
                            }}
                            className='shadow'
                            style={{
                                width: 290,
                                height: 70,
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginTop:10,
                                display: 'flex',
                                backgroundColor: '#fff',
                            }}>
                                <div style={{
                                    width: '100%',
                                    display: 'flex', justifyContent: 'center',
                                    position: 'relative',
                                    alignItems: 'center',}}>
                                        
                                        <p
                                    style={{
                                            fontWeight: '900',
                                            fontSize:30,
                                            color: '#ED3E08',
                                            textTransform: 'uppercase',
                                            textAlign: 'center',
                                            paddingHorizontal: 30,
                                            position: 'absolute',
                                        }}>
                                            imported
                                        </p>
                                </div>
                        </div>

                         <div onClick={() => {
                            setdishs(noalcol)
                            setShowListProduct(true)
                            }}
                            className='shadow'
                            style={{
                                width: 290,
                                height: 70,
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginTop:10,
                                display: 'flex',
                                backgroundColor: '#fff',
                            }}>
                                <div style={{
                                    width: '100%',
                                    display: 'flex', justifyContent: 'center',
                                    position: 'relative',
                                    alignItems: 'center',}}>
                                        
                                        <p
                                    style={{
                                            fontWeight: '900',
                                            fontSize:30,
                                            color: '#ED3E08',
                                            textTransform: 'uppercase',
                                            textAlign: 'center',
                                            paddingHorizontal: 30,
                                            position: 'absolute',
                                        }}>
                                            0 Alcohol
                                        </p>
                                </div>
                        </div>
                       
                    </div>
                                        
                    
                  
                </div>
                                        
                {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                />}

                {showBeers && <BeerScreen setShowHappy={setshowBeers} />}
                
                {/* 
                {showMargaritas && <MargaritasScreen setShowHappy={setshowMargaritas} />}
                {showWines && <WinesScreen setShowHappy={setshowWines} />}
                {showSpirits && <SpiritsScreen setShowHappy={setShowSpirits} />}
                {showBottles && <BottlesScreen setShowHappy={setshowBottles} />} */}
                
                     {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowHappy} />}
            </LayoutContent>
        </div>
    );
}
export default Index;